/* ICI CROCL v1 (2026-09-22) — CRO-CL Clarity.
   A4 complemento para cruzar el umbral de envío gratis · B1 "Cambiar búsqueda" ·
   C1 imágenes bajo el pliegue en lazy · F eventos Clarity.
   Config: window.ICI_CROCL (snippets/ici-crocl.liquid). Sin librerías externas.
   Rollback: quitar el render de snippets/ici-crocl.liquid en layout/theme.liquid. */
(function () {
  'use strict';
  var CFG = window.ICI_CROCL || {};
  var THR = CFG.thresholdCents || 4500;

  function track(ev, data) {
    try {
      if (!window.clarity) return;
      window.clarity('event', ev);
      if (data) Object.keys(data).forEach(function (k) { window.clarity('set', k, String(data[k])); });
    } catch (e) { }
  }
  function money(c) { return '$' + (c / 100).toFixed(2); }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
  function on(el, ev, fn) { if (el) el.addEventListener(ev, fn); }

  /* ───────── F · barra de envío: visto / desbloqueado ───────── */
  var barSeen = false, lastState = null;
  function watchBars() {
    var bars = document.querySelectorAll('[data-ici-envio-bar]');
    bars.forEach(function (bar) {
      var st = bar.getAttribute('data-state');
      if (lastState === 'pending' && st === 'free') track('ici_envio_bar_desbloqueado');
      if (st) lastState = st;
      if (bar.dataset.iciSeen) return;
      bar.dataset.iciSeen = '1';
      if (!('IntersectionObserver' in window)) { if (!barSeen) { barSeen = true; track('ici_envio_bar_visto'); } return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting && !barSeen) { barSeen = true; track('ici_envio_bar_visto'); io.disconnect(); }
        });
      }, { threshold: 0.5 });
      io.observe(bar);
    });
  }

  /* ───────── A4 · complementos para cruzar el umbral ───────── */
  var recCache = {};
  function fetchRecs(pid) {
    if (recCache[pid]) return recCache[pid];
    var base = CFG.recUrl || '/recommendations/products';
    var url = base + '.json?product_id=' + pid + '&limit=10&intent=complementary';
    recCache[pid] = fetch(url).then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (d) {
        var ps = d.products || [];
        if (ps.length < 3) {
          return fetch(base + '.json?product_id=' + pid + '&limit=10&intent=related')
            .then(function (r) { return r.ok ? r.json() : { products: [] }; })
            .then(function (d2) { return ps.concat(d2.products || []); });
        }
        return ps;
      }).catch(function () { return []; });
    return recCache[pid];
  }

  function cartRefresh(payloadSections) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function' && payloadSections) {
      try { drawer.renderContents(payloadSections); drawer.classList.remove('is-empty'); return true; } catch (e) { }
    }
    var items = document.querySelector('cart-items');
    if (items && typeof items.onCartUpdate === 'function') { try { items.onCartUpdate(); return true; } catch (e) { } }
    return false;
  }

  function addToCart(variantId, btn) {
    btn.disabled = true; btn.textContent = 'Agregando…';
    var drawer = document.querySelector('cart-drawer');
    var body = { items: [{ id: variantId, quantity: 1 }] };
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      try { body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; }); body.sections_url = window.location.pathname; } catch (e) { }
    }
    fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' }, body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (res) {
      track('ici_complemento_add');
      if (res.status && res.status >= 400) { btn.disabled = false; btn.textContent = 'Agregar'; return; }
      if (!cartRefresh(res)) window.location.reload();
      var main = document.querySelector('cart-items');
      if (main && CFG.page === 'cart') window.location.reload();
    }).catch(function () { btn.disabled = false; btn.textContent = 'Agregar'; });
  }

  function paintComp(box, products, left) {
    var grid = box.querySelector('[data-ici-comp-grid]');
    if (!grid) return;
    var max = left + 500;
    var inCart = {};
    try { (document.querySelectorAll('[data-ici-crocl-cart]') || []).forEach(function () { }); } catch (e) { }
    var picks = products.filter(function (p) {
      if (!p.available) return false;
      var v = (p.variants || []).filter(function (x) { return x.available; })[0];
      if (!v) return false;
      var price = typeof v.price === 'number' ? v.price : Math.round(parseFloat(v.price) * 100);
      if (isNaN(price) || price <= 0 || price > max) return false;
      p._v = v; p._price = price;
      return true;
    }).sort(function (a, b) {
      /* primero los que cruzan el umbral solos, luego por precio ascendente */
      var ca = a._price >= left ? 0 : 1, cb = b._price >= left ? 0 : 1;
      return ca - cb || a._price - b._price;
    }).slice(0, 3);
    if (!picks.length) { box.hidden = true; return; }
    grid.innerHTML = picks.map(function (p) {
      var img = p.featured_image || (p.images && p.images[0]) || '';
      if (typeof img === 'object' && img) img = img.src || img.url || '';
      if (img && img.indexOf('?') === -1) img += '?width=240';
      return '<li class="ici-crocl-comp__item">' +
        '<a class="ici-crocl-comp__img" href="' + esc(p.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="120" height="120">' : '') + '</a>' +
        '<span class="ici-crocl-comp__name">' + esc(p.title) + '</span>' +
        '<span class="ici-crocl-comp__price">' + money(p._price) + '</span>' +
        '<button type="button" class="ici-crocl-comp__btn" data-vid="' + p._v.id + '" aria-label="Agregar ' + esc(p.title) + '">Agregar</button></li>';
    }).join('');
    grid.querySelectorAll('.ici-crocl-comp__btn').forEach(function (b) {
      b.addEventListener('click', function () { addToCart(parseInt(b.getAttribute('data-vid'), 10), b); });
    });
    box.hidden = false;
  }

  function initComp() {
    document.querySelectorAll('[data-ici-comp]:not([data-ici-done])').forEach(function (box) {
      box.setAttribute('data-ici-done', '1');
      var wrap = box.closest('[data-ici-crocl-cart]');
      var pid = wrap ? parseInt(wrap.getAttribute('data-first'), 10) : (CFG.firstProductId || 0);
      var left = parseInt(box.getAttribute('data-left'), 10);
      if (!pid || isNaN(left) || left <= 0) return;
      fetchRecs(pid).then(function (ps) { paintComp(box, ps, left); });
    });
  }

  /* ───────── B1 · "Cambiar búsqueda" enfoca la barra oficial del header ───────── */
  function initSearchSwap() {
    var b = document.querySelector('[data-ici-cambiar-busqueda]');
    if (!b) return;
    b.addEventListener('click', function () {
      track('ici_cambiar_busqueda');
      var mob = document.querySelector('.ici-hdr-mob-search input');
      var desk = document.querySelector('.ici-hdr-search-field');
      var visible = function (el) { if (!el) return false; var r = el.getBoundingClientRect(); return r.width > 0 && r.height > 0; };
      var target = visible(mob) ? mob : (visible(desk) ? desk : null);
      if (target) { window.scrollTo({ top: 0, behavior: 'smooth' }); setTimeout(function () { target.focus(); try { target.select(); } catch (e) { } }, 300); return; }
      var mbar = document.getElementById('ici-mbar-search');
      if (mbar) { mbar.click(); return; }
      var sum = document.querySelector('details-modal.header__search summary');
      if (sum) { sum.click(); setTimeout(function () { var i = document.querySelector('details-modal.header__search input[name="q"]'); if (i) i.focus(); }, 200); }
    });
  }

  /* ───────── F · smart event de búsqueda del header ───────── */
  function initSearchSubmit() {
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f || !f.getAttribute) return;
      var action = f.getAttribute('action') || '';
      if (action.indexOf('/search') === -1) return;
      var i = f.querySelector('input[name="q"]');
      var q = i ? i.value.trim() : '';
      if (!q) return;
      track('ici_search_submit', { ici_search_term: q.slice(0, 80) });
    }, true);
  }

  /* ───────── E4 · Lucía en ficha ───────── */
  function initLucia() {
    document.querySelectorAll('[data-ici-lucia]').forEach(function (a) {
      a.addEventListener('click', function () { track('ici_lucia_ficha_click'); });
    });
  }

  /* ───────── C1 · imágenes bajo el pliegue ───────── */
  function lazyBelowFold() {
    try {
      if (CFG.page !== 'index') return;
      var vh = window.innerHeight || 800;
      var imgs = document.images, first = null;
      for (var i = 0; i < imgs.length; i++) {
        var im = imgs[i], r = im.getBoundingClientRect();
        if (r.width < 40 || r.height < 40) continue;
        if (r.top < vh && r.bottom > 0) { if (!first) first = im; continue; }
        if (r.top > vh * 1.5 && !im.complete) {
          if (im.getAttribute('loading') !== 'lazy') im.setAttribute('loading', 'lazy');
          if (!im.getAttribute('fetchpriority')) im.setAttribute('fetchpriority', 'low');
        }
      }
      if (first && !first.getAttribute('fetchpriority')) first.setAttribute('fetchpriority', 'high');
    } catch (e) { }
  }

  /* ───────── boot ───────── */
  var pending = null;
  function rescan() {
    watchBars(); initComp(); initLucia();
  }
  function boot() {
    rescan(); initSearchSwap(); initSearchSubmit(); lazyBelowFold();
    if ('MutationObserver' in window) {
      new MutationObserver(function () {
        if (pending) return;
        pending = setTimeout(function () { pending = null; rescan(); }, 150);
      }).observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
/* ICI CROCL-E6 v1 (2026-09-24) — reordena el buy box de la ficha (patrón Home Depot/Target):
   solo re-etiqueta y mueve nodos existentes; si algo no existe, no hace nada.
   Rollback: borrar este bloque hasta /ICI CROCL-E6 (y el bloque E6 de ici-crocl.css). */
(function(){
  if(!document.querySelector('.product__info-container')) return;
  var tries=0;
  function once(fn){var done=false;return function(){if(done)return true;var ok=fn();if(ok)done=true;return ok;};}
  /* 1) Tarjeta de retiro: título corto + tienda como subtítulo; el horario queda en el cajón "Ver tienda" */
  var pickup=once(function(){
    var info=document.querySelector('.product__info-container .pickup-availability-info');
    if(!info) return false;
    var t=info.querySelector('.caption-large'); if(!t) return false;
    var store=(t.querySelector('span')||{}).textContent||'';
    t.textContent='Retiro gratis en tienda';
    var c=info.querySelector('.caption');
    if(c && store) c.textContent=store.replace(/\s*-\s*Tienda\s*$/,'').replace('ICI | ','ICI ')+' · '+c.textContent.trim();
    var h=info.querySelector('.ici-pickup-horario'); if(h) h.classList.add('ici-e6-hide');
    var b=info.querySelector('.pickup-availability-button'); if(b) b.textContent='Ver tienda';
    return true;
  });
  /* 2) Tarjeta de envío: encabezado + fecha estimada (tomada del widget de entrega si ya cargó) */
  var ship=once(function(){
    var box=document.querySelector('.product__info-container .ici-shipping-text');
    if(!box) return false;
    var eta=document.querySelector('.essential-estimated-delivery-description');
    var txt=eta?eta.innerText.replace(/\s+/g,' '):'';
    if(!txt && tries<24) return false; /* espera hasta ~6 s al widget */
    var h=document.createElement('strong'); h.className='ici-e6-h'; h.textContent='Envío a todo el país';
    box.insertBefore(h, box.firstChild);
    var m=txt.match(/entre\s+(\S+)\s+(\d+)\s+y\s+(\S+)\s+(\d+)/i);
    if(m){var e=document.createElement('span'); e.className='ici-e6-eta';
      e.innerHTML='Recíbelo <strong>'+(m[1]===m[3]?m[2]+'–'+m[4]+' '+m[1]:m[2]+' '+m[1]+' – '+m[4]+' '+m[3])+'</strong>';
      box.insertBefore(e, h.nextSibling);}
    var free=box.querySelector('.ici-shipping-title'); if(free) box.appendChild(free);
    var sub=box.querySelector(':scope > span:not(.ici-e6-eta)'); if(sub) sub.classList.add('ici-e6-hide');
    return true;
  });
  /* 3) Widget de fechas (cuenta regresiva + línea de tiempo) → tarjeta Descripción/Especificaciones */
  var move=once(function(){
    var blk=document.querySelector('.product__info-container .essential-estimated-delivery-block');
    var grid=document.querySelector('.ici-desc-specs-grid');
    if(!blk || !grid) return false;
    var wrap=document.createElement('div'); wrap.className='ici-e6-delivery';
    wrap.innerHTML='<div class="ici-col-header"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="1" y="3" width="15" height="13"></rect><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon><circle cx="5.5" cy="18.5" r="2.5"></circle><circle cx="18.5" cy="18.5" r="2.5"></circle></svg><h3>Envío y entrega</h3></div><div class="ici-e6-delivery-body"></div>';
    wrap.querySelector('.ici-e6-delivery-body').appendChild(blk);
    grid.appendChild(wrap);
    return true;
  });
  /* 4) Ortografía del botón Lucía */
  var lu=document.querySelector('.ici-crocl-lucia span'); if(lu && /^Preguntale/.test(lu.textContent)) lu.textContent=lu.textContent.replace('Preguntale','Pregúntale');
  var t=setInterval(function(){ tries++; var a=pickup(), b=ship(), c=b&&move(); if((a&&b&&c)||tries>40) clearInterval(t); }, 250);
})();
/* /ICI CROCL-E6 */
